/**
 * Title-related GraphQL queries
 */

export const GET_TITLES_QUERY = `
  query GetTitles($where: titles_bool_exp) {
    titles(where: $where, order_by: { created_at: desc }) {
      id
      title_name
      title_code
      title_description
      title_status
      company_id
      created_at
      company {
        id
        name
      }
    }
  }
`;

export const GET_TITLE_BY_ID_QUERY = `
  query GetTitleById($id: Int!) {
    titles_by_pk(id: $id) {
      id
      title_name
      title_code
      title_description
      title_status
      company_id
      created_at
    }
  }
`;
